var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.injectedStyle),attrs:{"id":"app"}},[_c('TheNavBar'),_c('router-view',{staticClass:"router-content"}),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }